import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbDropdownModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";

import { CreateTransformationComponent } from "./pages/transformation-collaborator/create-trasformation/create-transformation.component";
import { EditTransformationComponent } from "./pages/transformation-collaborator/edit-trasformation/edit-transformation.component";
import { TransformationListComponent } from "./pages/transformation-collaborator/trasformation-list/transformation-list.component";
import { TransformationSelectComponent } from "./pages/transformation-collaborator/transformation-select/transformation-select.component";
import { EditMyProfileCollaboratorComponent } from "./pages/edit-my-profile-collaborator/edit-my-profile-collaborator.component";
import { FormAddCollaboratorComponent } from "./pages/form-add-collaborator/form-add-collaborator.component";
import { FormEditCollaboratorComponent } from "./pages/form-edit-collaborator/form-edit-collaborator.component";
import { ListCollaboratorsComponent } from "./pages/list-collaborators/list-collaborators.component";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as collaboratorsIt } from "../collaborators/i18n/collaboratorsIt";
import collaboratorsMenu from "./collaborators.menu";
import { RouterModule } from "@angular/router";
import collaboratorsRoutes from "./collaborators.routes";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { CoreCardModule } from "../../../@core/components/core-card/core-card.module";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CollaboratorsCostsComponent } from './pages/collaborators-costs/collaborators-costs.component';
import { LayoutModule } from "../../layout/layout.module";

@NgModule({
  declarations: [
    CreateTransformationComponent,
    EditTransformationComponent,
    TransformationListComponent,
    TransformationSelectComponent,
    EditMyProfileCollaboratorComponent,
    FormAddCollaboratorComponent,
    FormEditCollaboratorComponent,
    ListCollaboratorsComponent,
    CollaboratorsCostsComponent,
  ],
  imports: [
    CommonModule,
    ContentHeaderModule,
    RouterModule.forChild(collaboratorsRoutes),
    TranslateModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
    ReactiveFormsModule,
    NgSelectModule,
    ExtendedModule,
    CoreCommonModule,
    NgbDropdownModule,
    CoreCardModule,
    DragDropModule,
    LayoutModule
  ]
})
export class CollaboratorsModule {
  constructor(private _utilService: UtilsService) {
    this._utilService.initModule("collaborators", collaboratorsIt, collaboratorsMenu, []);
  }
}
